export const criteri = [
	"Sintomatico (sospetto COVID)",
	"Contatto stretto asintomatico (tampone molecolare)",
	"Test per soggetto Donatore Sangue",
	"Pauci-sintomatico con test rapido positivo. NO link epidemiologico",
	"Contatto stretto asintomatico che frequenta o convive con fragili",
	"Sorveglianza medico competente",
	"Screening di comunità a seguito di test salivare rapido positivo",
	"Screening di comunità con test rapido positivo. NO link epidemiologico",
	"Accesso struttura con test rapido positivo. NO link epidemiologico",
]

export const motivazioni = [
	"Screening Altre residenze",
	"Screening Ospedaliero",
	"Screening RSA",
	"Fine Isolamento Fiduciario",
	"Contatto - Altro",
	"Contatto - App Immuni",
	"Contatto - Familiare",
	"Contatto - Lavorativo",
	"Contatto - Scolastico",
	"Sintomi",
	"Screening personale scolastico",
	"Motivi di lavoro",
	"Verifica negatività ai fini donazionali"
]
